import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { brandGroupIdAtom, surveyFilterAtom } from '~/atoms'
import { useSurveyQueryData } from '~/hooks/useSurveyQuery'
import { assertExists } from '~/utils'

export const useCreateSurveyFilterRestoringParams = () => {
  const { t } = useTranslation()
  const survey = useSurveyQueryData()

  const brandGroupId = useAtomValue(brandGroupIdAtom)
  const surveyFilter = useAtomValue(surveyFilterAtom)

  return React.useCallback(
    <RestoringParams>(path: string, state: RestoringParams) => {
      assertExists(survey, t('assertion_failed'))
      assertExists(brandGroupId, t('assertion_failed'))

      const brandAccountId = survey.brandAccountId
      const surveyId = survey.id

      return {
        brandAccountId,
        replace: {
          path: compile('restoreSurveyFilter', { surveyId }),
          state: {
            surveyFilter: {
              surveyId,
              filterGroups: surveyFilter?.filterGroups ?? [],
            },
            replace: { path, state },
          },
        },
      }
    },
    [brandGroupId, survey, surveyFilter?.filterGroups, t],
  )
}
